import React from 'react';
import { Box } from '@chakra-ui/react';
import BasicCertification from './BasicCertification';
import PillarCertification from './PillarCertification';

const CertificationContent = ({
 selectedCertificationId,
 selectedCompanyId,
 hasPillars,
 surveyId,
 companyGroupId,
 companyName,
 isResponsibleUser = false,
 idLinkGroup,
 linkStatus,
}) => {
 return (
  <Box>
   {hasPillars ? (
    <PillarCertification
     companyGroupId={companyGroupId}
     selectedCertificationId={selectedCertificationId}
     selectedCompanyId={selectedCompanyId}
     surveyId={surveyId}
     isResponsibleUser={isResponsibleUser}
     companyName={companyName}
    />
   ) : (
    <BasicCertification
     companyGroupId={companyGroupId}
     selectedCertificationId={selectedCertificationId}
     selectedCompanyId={selectedCompanyId}
     isResponsibleUser={isResponsibleUser}
     idLinkGroup={idLinkGroup}
     linkStatus={linkStatus}
    />
   )}
  </Box>
 );
};

export default CertificationContent;
